"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultPhoneHelpers = exports.StaticPhoneHelper = void 0;
const utils_1 = require("./utils");
class StaticPhoneHelper {
    static validatePhone(phone, { validationRegex }) {
        const unformattedPhone = StaticPhoneHelper.unFormatPhone(phone);
        return validationRegex.test(unformattedPhone);
    }
    static formatPhone(phone, { phoneMask, validationRegex }) {
        const unformattedPhone = StaticPhoneHelper.unFormatPhone(phone);
        if (!StaticPhoneHelper.validatePhone(unformattedPhone, { validationRegex })) {
            return '';
        }
        return (0, utils_1.formatPhoneByPassedMask)(unformattedPhone, phoneMask);
    }
    static unFormatPhone(phone) {
        return phone.replace(/[^\d*]/g, '');
    }
    static concatCountryCode(phone, { countryCode }) {
        return `+${countryCode} ${phone}`;
    }
    static obfuscatePhone(phone, { obfuscateMask, validationRegex }) {
        const unformattedPhone = StaticPhoneHelper.unFormatPhone(phone);
        if (!StaticPhoneHelper.validatePhone(unformattedPhone, { validationRegex })) {
            return '';
        }
        return (0, utils_1.formatPhoneByPassedMask)(unformattedPhone, obfuscateMask);
    }
}
exports.StaticPhoneHelper = StaticPhoneHelper;
class DefaultPhoneHelpers extends StaticPhoneHelper {
    constructor(config) {
        super();
        this.config = config;
    }
    get phoneMask() {
        return this.config.phoneMask;
    }
    get countryCode() {
        return this.config.countryCode;
    }
    get countryFlag() {
        return this.config.countryFlag ?? '';
    }
    validatePhone(phone) {
        return DefaultPhoneHelpers.validatePhone(phone, this.config);
    }
    formatPhone(phone) {
        return DefaultPhoneHelpers.formatPhone(phone, this.config);
    }
    unFormatPhone(phone) {
        return DefaultPhoneHelpers.unFormatPhone(phone);
    }
    concatCountryCode(phone) {
        return DefaultPhoneHelpers.concatCountryCode(phone, this.config);
    }
    obfuscatePhone(phone) {
        return DefaultPhoneHelpers.obfuscatePhone(phone, this.config);
    }
}
exports.DefaultPhoneHelpers = DefaultPhoneHelpers;
//# sourceMappingURL=DefaultPhoneHelpers.js.map